import { coerceFunctions, createTypedBindable } from 'aurelia-typed-observable-plugin';
coerceFunctions.none = function (a) {
    return a;
};
createTypedBindable('none');
//# sourceMappingURL=aurelia-typed-observable-plugin-fix.js.map